import axios from '../request/http.js'

class Department {
  /* 部门列表查询 */
  static getDepartmentList(id, queryStr) {
    const url = `/zzd/api/back/dept/list/additional?id=${id}&queryStr=${queryStr}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 添加部门 */
  static postAddDepartment(data) {
    const url = `/zzd/api/back/dept/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除部门 */
  static postDelDepartment(data) {
    const url = `/zzd/api/back/dept/delete`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑部门 */
  static postModDepartment(data) {
    const url = `/zzd/api/back/dept/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取组织框架及四级部门的成员 */
  static getDepartmentPeopleList(id, queryStr) {
    const url = `/zzd/api/back/user/list/member?id=${id}&queryStr=${queryStr}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取部门详情 */
  static getDepartmentDetails(id) {
    const url = `/zzd/api/back/dept/detail/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }

}

export default Department;